<template>
  <div>
    <listado-tarifas-de-lineas-tabla :data="data" />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

import { getTarifasLineas } from "@/constants/lineas";

import ListadoTarifasDeLineasTabla from "../../../components/tablas/lineas/ListadoTarifasDeLineasTabla";

export default {
  components: { ListadoTarifasDeLineasTabla },
  data() {
    return {
      data: [],
    };
  },
  computed: {
    ...mapState(["token"]),
    ...mapState("lineas", ["dataDatatableTarifasLineas"]),
  },
  methods: {
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoadingTable"
    ]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasLineas",
      "actionSetDataListaNavierasNoUCC"
    ]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasAcuerdosLineas",
      "actionSetDataListaPOD",
      "actionSetDataListaPOL",
      "actionSetDataListaNaviera",
      "actionSetDataListaProducto",
      "actionSetDataListaDestinos",
      "actionSetDataContenedores"
    ]),
    ...mapActions("administracion", ["actionSetDataAtmosferas"]),

    // Función para actualizar url en state
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

    // Obteneción de tarifas lineas desde la BD
    async getListaTarifasLineas() {
      //
      this.ActionSetLoadingTable(true);

      //
      let {
        data_table,
        filtros_pod,
        filtros_pol,
        filtros_navieras,
        filtros_navieras_no_ucc,
        filtros_productos,
        filtros_destinos,
        filtros_atmosfera,
        filtro_contenedor
      } = await getTarifasLineas();

      //
      this.actionSetDataListarTarifasLineas(data_table);

      // Filtros
      this.actionSetDataListaPOD(filtros_pod);
      this.actionSetDataListaDestinos(filtros_destinos);
      this.actionSetDataListaProducto(filtros_productos);
      this.actionSetDataListaPOL(filtros_pol);
      this.actionSetDataListaNaviera(filtros_navieras);
      this.actionSetDataListaNavierasNoUCC(filtros_navieras_no_ucc);
      this.actionSetDataAtmosferas(filtros_atmosfera);
      this.actionSetDataContenedores(filtro_contenedor);

      this.ActionSetLoadingTable(false);
    },
  },
  created() {
    this.getListaTarifasLineas();
    this.actualizarURL();
  },
  watch: {
    dataDatatableTarifasLineas: function (_new) {
      if (_new) {
        this.data = _new;
      }
    },
  },
};
</script>
<style></style>
